import React, { useEffect, useState, useContext } from "react";
import Spinner from "../Spinner/Spinner";
import "./Functions.css";
import FunctionGridItem from "./GridItem/FunctionGridItem";
import { LanguageContext } from "../../context/LanguageContext";
// import Modal from 'react-bootstrap/Modal';
import YouTube from "react-youtube";

import "bootstrap/dist/css/bootstrap.min.css";

const Functions = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { language } = useContext(LanguageContext);
  // const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    const getConent = async () => {
      if (language === "german") {
        const res = await fetch(
          "https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=3"
        );
        const data = await res.json();
        for (let i = 0; i < data.length; i++) {
          const resimg = await fetch(
            `https://swissmailsecurity.ch/wp-json/wp/v2/media/${data[i].featured_media}`
          );
          const image = await resimg.json();
          data[i]["image_url"] = image.source_url;
        }
        setData(data);
        setIsLoading(false);
      } else if (language === "french") {
        const res = await fetch(
          "https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=8"
        );
        const data = await res.json();
        for (let i = 0; i < data.length; i++) {
          const resimg = await fetch(
            `https://swissmailsecurity.ch/wp-json/wp/v2/media/${data[i].featured_media}`
          );
          const image = await resimg.json();
          data[i]["image_url"] = image.source_url;
        }

        setData(data);
        setIsLoading(false);
      }
    };

    getConent();
  }, [language]);

  // const handleModalShow = () => {
  //   setIsShowing(true);
  // }

  // const handleModalClose = () => {
  //   setIsShowing(false);
  // }

  const onPlayerReady = (event) => {
    event.target.pauseVideo();
  };

  const opts = {
    playerVars: {
      // autoplay: 1,
    },
  };

  return (
    <div className="functions_container">
      <div className="functions_inner_container">
        <div className="functions_title">
          <span className={language === "german" ? "" : "functions_title_span"}>
            {" "}
            {language === "german"
              ? "So Funktioniert E-mail Security"
              : "Comment fonctionne la sécurité de la messagerie"}
          </span>
          <h3 className={language === "german" ? "" : "functions_title_h3"}>
            {language === "german"
              ? "Auf clevere Schweizer Art"
              : "électronique à la manière intelligente suisse"}
          </h3>
        </div>
        {isLoading ? (
          <div className="functions_content_loading">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="functions_grid_container">
              {data.map((item, index) => {
                return (
                  <FunctionGridItem
                    key={index}
                    red={index % 2 === 0}
                    data={item.content.rendered}
                    image={item.image_url}
                  />
                );
              })}
            </div>

            <YouTube
              videoId="r4pgLSPgb8o"
              opts={opts}
              onReady={onPlayerReady}
              className="inline__video"
            />

            {/* <div className="functions_button_container">
            <div className="functions_button">
              <button onClick={handleModalShow}>VIDEO</button>
            </div>
          </div>
          <Modal show={isShowing} onHide={handleModalClose}>
            <Modal.Body>
              <YouTube videoId="r4pgLSPgb8o" opts={opts} onReady={onPlayerReady} />
            </Modal.Body>
            <Modal.Footer>
              <button className="main_button" onClick={handleModalClose}>
                Close
              </button>
            </Modal.Footer>
          </Modal> */}
          </>
        )}
      </div>
    </div>
  );
};

export default Functions;
